import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const GoverningLawTermsOfUse = () => {
  const { classes } = useTOCStyles();

  return (
    <div>
      <SectionHeader title="Governing Law" />
      <ol start={27}>
        <li className={classes.paragraph}>
          <Typography variant="body1">
            These Terms of Use shall be governed and construed in accordance with laws of the
            Republic of Singapore.
          </Typography>
        </li>
      </ol>
    </div>
  );
};

export default GoverningLawTermsOfUse;
